import React from 'react';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import { Link } from 'gatsby';

const Madarij = () => (
  <Layout>
    <Sidebar showTabs="madarij" />
    <div className="container-fluid p-0">
      <section className="resume-section p-3 p-lg-5 d-flex justify-content-center" id="happy">
        <div className="w-100">
          <h2 style={{ textAlign: 'center' }}>PATH 2: The Journey</h2>
          <h3 style={{ textAlign: 'center' }}>Practical Steps to Happiness From Madarij Assalekin (Ibn Al-Qayyim)</h3>
          <h3 style={{ textAlign: 'center' }}>مدارج السالكين</h3>
          
          <p style={{ fontSize: '18px', color: '#17a2b8', marginTop: '2rem' }}>
            This is a practical workshop to reach happiness in this life and the hereafter. 
            We will go through the steps of the travelers by Ibn Al-Qayyim مدارج السالكين.
          </p>

          <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <h4>Follow the Series:</h4>
            <ul style={{ fontSize: '18px' }}>
              <li>
                <a href="https://www.youtube.com/@myislamnet" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i> YouTube Channel
                </a>
              </li>
              <li>
                <a href="https://medium.com/@myjourneyinlife" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-medium"></i> Medium Articles
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/playlist?list=PLNT8BTFvQYHLWc7EkqE0OYo1sRCuQwYzv" target="_blank">
                  YouTube PlayList - Practical Steps to happiness
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/groups/701352733924789" target="_blank">
                  <i className="fab fa-facebook-f"></i> Facebook Group
                </a>
              </li>
            </ul>
          </div>

          <h3>The Journey - Spiritual States (المنازل)</h3>
          
          <ul style={{ fontSize: '18px', lineHeight: '2' }}>
            <li>
              <Link to="/ramadan/">Ramadan</Link>
            </li>
            <li>
              <Link to="#gratitude">The State of Gratitude - منزلة الشكر</Link>
            </li>
            <li>
              <Link to="#grief">The State of Grief - منزلة الحزن</Link>
            </li>
            <li>
              <Link to="/love/">The State of Love - منزلة المحبة</Link>
            </li>
            <li>
              <Link to="#patience">The State of Patience - منزلة الصبر</Link>
            </li>
            <li>
              <Link to="#trust">The State of Trust - منزلة الثقة</Link>
            </li>
            <li>
              <Link to="#stage1">Stages 1-4: Consciousness - Commitment - اليقظة - العزم</Link>
            </li>
            <li>
              <Link to="#step4">Perfection - Ehsan - منزلة الاحسان</Link>
            </li>
            <li>
              <Link to="#Sincerity">The State of Sincerity - منزلة الاخلاص</Link>
            </li>
            <li>
              <Link to="#heart">Protect Your Heart</Link>
            </li>
            <li>
              <Link to="#help">Ask Allah For Help</Link>
            </li>
            <li>
              <Link to="#introduction">Introduction</Link>
            </li>
          </ul>

          <h4 style={{ marginTop: '2rem' }}>
            <Link to="#references">References & Resources</Link>
          </h4>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="introduction">
        <div className="w-100">
          <h4>Introduction</h4>
          <ul>
            <li>
              <a href="https://youtu.be/5ffrMcPFgTQ" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://myislam.net/static/1_Practical_Steps_to_Happiness_Introduction_Final.pdf" target="_blank">
                Slides in PDF format
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/1_Practical_Steps_to_Happiness_Introduction.pptx" target="_blank">
                Slides in PowerPoint format with voice
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/happiness_1.mp4" target="_blank">Video in .mp4 format</a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="help">
        <div className="w-100">
          <h4>Ask Allah For Help (Duaa and Monajah)</h4>
          <ul>
            <li>
              <Link to="/duaa/">Complete Duaa Guide</Link>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="stage1">
        <div className="w-100">
          <h4>Stages 1-4: Consciousness - Commitment - اليقظة - الفكرة البصيرة - العزم</h4>
          <ul>
            <li>
              <a href="https://youtu.be/l7dGtFTfy0Y" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://myislam.net/static/1_Steps_1-4.pdf" target="_blank">Slides in PDF format</a>
            </li>
            <li>
              <a href="https://myislam.net/static/1_Madarej_Setps1-4.pptx" target="_blank">
                Slides in PowerPoint format with voice
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/1_Madarej_Setps1-4.mp4" target="_blank">Video in .mp4 format</a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="step5">
        <div className="w-100">
          <h4>Step 5: Self-Evaluation - المحاسبة</h4>
          <ul>
            <li>
              <a href="https://MyIslam.net/static/Self_Evaluation.pdf" target="_blank">Written PDF to read</a>
            </li>
            <li>
              <a href="https://youtu.be/LjoQOXT3hY0" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://youtu.be/myGZ0EgvCfU" target="_blank">Preparation YouTube Video - 2014</a>
            </li>
            <li>
              <a href="https://myislam.net/static/2020Sept25Plan.pdf" target="_blank">Plan before the session in PDF format</a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="step6">
        <div className="w-100">
          <h4>Step 6: Repentance - التوبة</h4>
          <ul>
            <li>
              <a href="https://MyIslam.net/static/3_Step6_Repemtance.pdf" target="_blank">Written PDF to read</a>
            </li>
            <li>
              <a href="https://youtu.be/TP-X1ME9Ivs" target="_blank">Practicing Repentance Step 1 YouTube Video</a>
            </li>
            <li>
              <a href="https://youtu.be/XhrvEYD8BZY" target="_blank">Practicing Repentance 2 - People's Right</a>
            </li>
            <li>
              <a href="https://MyIslam.net/static/2020Oct2Plan.pdf" target="_blank">Plan before the session in PDF format</a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="Sincerity">
        <div className="w-100">
          <h4>Sincerity - الاخلاص</h4>
          <ul>
            <li>
              <a href="https://youtu.be/YT1EXbGnJy8" target="_blank">YouTube Video</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="step4">
        <div className="w-100">
          <h4>Perfection - Ehsan - الاحسان</h4>
          <ul>
            <li>
              <a href="https://youtu.be/txyYXI-xfPE" target="_blank">YouTube Video</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="trust">
        <div className="w-100">
          <h3>The State of Trust - منزلة الثقة</h3>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <a href="https://youtu.be/C_XCaiwNO3M" target="_blank">
                [English - YouTube Video] The State of Trust - منزلة الثقة
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/trust.pdf" target="_blank">The session Written to read and download in PDF Format</a>
            </li>
            <li>
              <a href="https://myislam.net/static/2020Oct2Plan.pdf" target="_blank">
                This week's Suggested Activities (How to practice)
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/Trust.pptx" target="_blank">Slides with Audio in PowerPoint Format</a>
            </li>
            <li>
              <a href="https://myislam.net/static/Trust.mp4" target="_blank">Video in .mp4 format</a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="patience">
        <div className="w-100">
          <h3>The State of Patience - منزلة الصبر</h3>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <a href="https://youtu.be/1nS1x7U1Fcc" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://myislam.net/static/patience.m4a" target="_blank">Audio file</a>
            </li>
            <li>
              <a href="https://myislam.net/static/patience.pdf" target="_blank">The session Written to read and download in PDF Format</a>
            </li>
            <li>
              <a href="https://myislam.net/static/PracticePatience.pdf" target="_blank">
                This week's Suggested Activities (How to become Patient)
              </a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="gratitude">
        <div className="w-100">
          <h3>The State of Gratitude - منزلة الشكر</h3>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <a href="https://youtu.be/Y1m8V-CeQ_c" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://myislam.net/static/PowerOfGratitude.pdf" target="_blank">
                The session Written to read and download in PDF Format
              </a>
            </li>
            <li>
              <a href="https://myislamnet.medium.com/the-power-of-gratitude-in-reaching-happiness-and-treating-stress-anxiety-and-depression-d5c8a38a3e05" target="_blank">
                Medium Article
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/PowerOfGratitude.pdf" target="_blank">
                This week's Suggested Activities (How to become Grateful)
              </a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="grief">
        <div className="w-100">
          <h3>The State of Grief - منزلة الحزن</h3>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <a href="https://youtu.be/9v66GblzYVw" target="_blank">YouTube Video</a>
            </li>
            <li>
              <a href="https://myislamnet.medium.com/grief-and-how-to-overcome-it-90389e43505f?source=friends_link&sk=a45a10ff3759af0700cea3ecc00eca61" target="_blank">
                Medium Article
              </a>
            </li>
            <li>
              <a href="#happy" style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }}>Back to Top</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="heart">
        <div className="w-100">
          <h4>Protect Your Heart</h4>
          <ul>
            <li>
              <a href="https://youtu.be/un0_9nQXdnU" target="_blank">YouTube Video</a>
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="references">
        <div className="w-100">
          <h4>References & Resources</h4>
          <ul>
            <li>
              <a href="https://youtube.com/playlist?list=PLhbs8A5De9zSVObgh99rhe7FDHdw69Ua2" target="_blank">
                [Arabic - YouTube PlayList] حياة الإحسان 2022 - الحلقات كاملة
              </a>
            </li>
            <li>
              <span>[English] Translation of the Book Ranks of the divine seekers</span>
              <a href="https://myislam.net/static/english_madarij_1.pdf" target="_blank"> Part 1</a>
              <a href="https://myislam.net/static/english_madarij_2.pdf" target="_blank">, Part 2</a>
            </li>
            <li>
              <a href="https://www.youtube.com/playlist?list=PLNT8BTFvQYHLmHSeXABFEYS-hZ9IwGdWI" target="_blank">
                [English - YouTube PlayList] Practicing Madarej Assalekeen - تطبيق كتاب مدارج السالكين
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/Summary_Of_Madarej.pdf" target="_blank">
                [English - PDF] Practicing Madarej Assalekeen - تطبيق كتاب مدارج السالكين
              </a>
            </li>
            <li>
              <a href="https://www.amazon.com/dp/B08KP6QQV3" target="_blank">
                [English - Amazon Kindle Book] Practicing Madarej Assalekeen
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/Madarij-as-Salikeen-Imam-Ibn-Qayim-Al-Jawziyah-ENG.pdf" target="_blank">
                [English] Book of Madarij Assalekeen - كتاب مدارج السالكين
              </a>
            </li>
            <li>
              <a href="https://ar.wikisource.org/wiki/%D9%85%D8%AF%D8%A7%D8%B1%D8%AC_%D8%A7%D9%84%D8%B3%D8%A7%D9%84%D9%83%D9%8A%D9%86" target="_blank">
                [Arabic] Book of Madarij Assalekeen - كتاب مدارج السالكين ابن قيم الجوزية
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/Madarej_Book_Arabic.pdf" target="_blank">
                [Arabic - pdf] Book of Madarij Assalekeen - كتاب مدارج السالكين ابن قيم الجوزية
              </a>
            </li>
            <li>
              <a href="https://sunnah.com/" target="_blank">https://sunnah.com/</a>
            </li>
            <li>
              <a href="https://www.dorar.net/hadith" target="_blank">https://www.dorar.net/hadith</a>
            </li>
            <li>
              <a href="https://www.islamicity.org/quransearch/" target="_blank">Quran SmartSearch</a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </Layout>
);

export default Madarij;
